import StyleTable from "../Components/Styles/StyleTable"
import VibesTable from "../Components/Vibes/VibeTable"
import { useGetStylesQuery } from '../Slices/roomNateApis'

const Vibes = () => {
    const { data: FetchStyles, isLoading } = useGetStylesQuery()

    return (
        <>
            <StyleTable FetchStyles={FetchStyles} isLoading={isLoading} />
            <div style={{ margin: "25px 0px" }}></div>
            <VibesTable FetchStyles={FetchStyles} />
        </>
    )
}

export default Vibes